import { Vector3 } from "three";
import { Viewer } from "../main";
import { CameraImage } from "../cameras";

export class ChangeDetector {
  private viewer: Viewer;

  public cameraChanged;
  public orbitChanged;

  private previous = {
    fov: 0,
    zoom: 0,
    camera: null as CameraImage,
    height: 0,
    width: 0,
    orbit: false,
    lookatVector: new Vector3(),
    upVector: new Vector3(),
    position: new Vector3()
  }

  public changed = false;

  constructor(viewer: Viewer) {
    this.viewer = viewer;
  }

  get newFov() {
    return this.viewer.fov;
  }

  get newZoom() {
    return this.viewer.getAerialZoomLevel();
  }

  get newLookatVector() {
    return this.viewer.lookatVector;
  }

  get newUpVector() {
    return this.viewer.upVector;
  }

  get newCamera() {
    return this.viewer.getCurrentCameraName();
  }

  get newHeight() {
    return this.viewer.height;
  }

  get newWidth() {
    return this.viewer.width;
  }

  get newOrbit() {
    return this.viewer.orbitState;
  }

  get newCameraPosition() {
    const camera = this.viewer.camera;
    return camera.position.clone();
  }

  update() {
    this.changed = false;

    try {
      let lookatChanged = this.previous.lookatVector
        .angleTo(this.newLookatVector) > 1e-5;

      let upChanged = this.previous.upVector
        .angleTo(this.newUpVector) > 1e-5;

      let positionChanged = this.previous.position
        .distanceTo(this.newCameraPosition) > 1e-5;

      let fovChanged = this.previous.fov !== this.newFov;
      let zoomChanged = this.previous.zoom !== this.newZoom;
      this.cameraChanged = this.previous.camera !== this.newCamera;
      let heightChanged = this.previous.height !== this.newHeight;
      let widthChanged = this.previous.width !== this.newWidth;
      this.orbitChanged = this.previous.orbit !== this.newOrbit;

      this.previous = {
        zoom: this.newZoom,
        fov: this.newFov,
        lookatVector: this.newLookatVector,
        upVector: this.newUpVector,
        camera: this.newCamera,
        height: this.newHeight,
        width: this.newWidth,
        orbit: this.newOrbit,
        position: this.newCameraPosition
      };

      this.changed = lookatChanged
        || upChanged
        || fovChanged
        || zoomChanged
        || this.cameraChanged
        || heightChanged
        || widthChanged
        || this.orbitChanged
        || positionChanged;
    } catch {
      this.changed = false;
    }
  };
}